import { StrictMode, type ComponentType } from 'react'
import { createRoot } from 'react-dom/client'
import { brandVertical, resolveSurface, type Surface } from './app/surface'
import { getManifest } from './verticals/manifests'
import './styles/fonts'
import './styles/index.css'

const surface = resolveSurface(window.location)
document.documentElement.dataset.surface = surface.kind
document.title = getManifest(brandVertical(surface)).brand.name

const loaders: Record<
  Surface['kind'],
  () => Promise<{ default: ComponentType<{ surface: never }> }>
> = {
  admin: () => import('./surfaces/admin/AdminApp'),
  platform: () => import('./surfaces/admin/AdminApp'),
  guest: () => import('./surfaces/guest/GuestApp'),
  root: () => import('./surfaces/root/RootApp'),
}

const container = document.getElementById('root')
if (!container) throw new Error('Missing #root element')

void loaders[surface.kind]().then(({ default: App }) => {
  const Surface = App as ComponentType<{ surface: Surface }>
  createRoot(container).render(
    <StrictMode>
      <Surface surface={surface} />
    </StrictMode>,
  )
})
